import { render, staticRenderFns } from "./ClsQuestion.vue?vue&type=template&id=a39d3c5c&scoped=true"
import script from "./ClsQuestion.vue?vue&type=script&lang=js"
export * from "./ClsQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39d3c5c",
  null
  
)

export default component.exports